
// import React, { useState, useEffect } from "react";
// import { Modal, Form, Button } from "react-bootstrap";
// import {
//   TextField,
//   MenuItem,
//   IconButton,
//   InputAdornment,
//   Button as MuiButton,
// } from "@mui/material";
// import { CheckCircle, Close } from "@mui/icons-material";
// import { toast, Toaster } from "react-hot-toast";

// const LeadCaptureModal = ({ show, onHide }) => {
//   const [loading, setLoading] = useState(false);
//   const [name, setName] = useState("");
//   const [number, setNumber] = useState("");
//   const [role, setRole] = useState("");
//   const [errors, setErrors] = useState({});

//   // OTP State
//   const [showOtpSection, setShowOtpSection] = useState(false);
//   const [isPhoneVerified, setIsPhoneVerified] = useState(false);
//   const [otp, setOtp] = useState(Array(6).fill(""));
//   const [timer, setTimer] = useState(30);
//   const [canResend, setCanResend] = useState(false);

//   // Map internal menu values to expected payload values
//   const roleMapping = {
//     Broker: "broker",
//     Developer: "developer",
//     "Real Estate Professional": "realEstate",
//   };

//   // OTP Resend Timer
//   useEffect(() => {
//     let interval;
//     if (showOtpSection && timer > 0 && !isPhoneVerified) {
//       interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
//     } else if (timer === 0) {
//       setCanResend(true);
//     }
//     return () => clearInterval(interval);
//   }, [showOtpSection, timer, isPhoneVerified]);

//   const handleSendOtp = async () => {
//     const contactRegex = /^\d{10}$/;
//     if (!number.trim() || !contactRegex.test(number)) {
//       setErrors((prev) => ({
//         ...prev,
//         contactNo: "Enter a valid 10-digit number",
//       }));
//       return;
//     }

//     setLoading(true);
//     try {
//       // Step 1: Pre-check user availability
//       const checkUserRes = await fetch(
//         "https://apilead.blaccdot.com/api/auth/check-user",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ phone: number }),
//         }
//       );
//       const checkUserData = await checkUserRes.json();

//       if (!checkUserRes.ok || checkUserData?.success === false) {
//         toast.error(checkUserData?.message || "User validation failed");
//         return;
//       }

//       // Step 2: Send OTP
//       const otpRes = await fetch(
//         "https://euctostaging.com/lms/api/send-otp",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ phone_number: number }),
//         }
//       );
//       const otpData = await otpRes.json();

//       if (otpRes.ok && otpData.success) {
//         toast.success(otpData.message || "OTP sent successfully!");
//         setShowOtpSection(true);
//         setTimer(30);
//         setCanResend(false);
//         setErrors((prev) => ({ ...prev, contactNo: "" }));
//       } else {
//         toast.error(otpData.message || "Failed to send OTP");
//       }
//     } catch (err) {
//       toast.error("Error sending OTP");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleVerifyOtp = async () => {
//     const fullOtp = otp.join("");
//     if (fullOtp.length !== 6) {
//       toast.error("Enter complete 6-digit OTP");
//       return;
//     }

//     setLoading(true);
//     try {
//       const res = await fetch(
//         "https://euctostaging.com/lms/api/verify-otp",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ phone_number: number, otp: fullOtp }),
//         }
//       );

//       const result = await res.json();

//       if (result.success) {
//         toast.success(result.message || "Mobile number verified!");
//         setIsPhoneVerified(true);
//         setShowOtpSection(false);
//       } else {
//         toast.error(result.message || "Invalid OTP. Try again.");
//       }
//     } catch (err) {
//       toast.error("OTP verification failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChangeOtp = (e, index) => {
//     const value = e.target.value.replace(/[^0-9]/g, "");
//     if (value.length > 1) return;
//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);

//     if (value && index < 5) {
//       document.getElementById(`modal-otp-${index + 1}`)?.focus();
//     }
//   };

//   const handleKeyDownOtp = (e, index) => {
//     if (e.key === "Backspace") {
//       if (otp[index]) {
//         const newOtp = [...otp];
//         newOtp[index] = "";
//         setOtp(newOtp);
//       } else if (index > 0) {
//         const newOtp = [...otp];
//         newOtp[index - 1] = "";
//         setOtp(newOtp);
//         document.getElementById(`modal-otp-${index - 1}`)?.focus();
//       }
//       e.preventDefault();
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const errs = {};
//     if (!name.trim()) errs.name = "Name is required";
//     if (!role) errs.role = "Please select a role";
//     if (!number.trim() || !/^\d{10}$/.test(number))
//       errs.contactNo = "Enter a valid 10-digit number";

//     setErrors(errs);
//     if (Object.keys(errs).length > 0) return;

//     if (!isPhoneVerified) {
//       toast.error("Please verify your mobile number first!");
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await fetch(
//         "https://apilead.blaccdot.com/api/auth/user-interaction",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             name: name,
//             mobileNo: number,
//             userCategory: roleMapping[role],
//           }),
//         }
//       );

//       const data = await response.json();

//       if (response.ok && data?.success !== false) {
//         toast.success(data?.message || "Details submitted successfully!");
//         onHide();
//       } else {
//         toast.error(data?.message || "Failed to submit interaction details");
//       }
//     } catch (err) {
//       toast.error("Error submitting details");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Toaster position="top-center" containerStyle={{ zIndex: 99999 }} />

//       <style>{`
//         @media (max-width: 576px) {
//           .custom-responsive-modal .modal-dialog {
//             margin-left: 16px !important;
//             margin-right: 16px !important;
//             max-width: calc(100% - 32px) !important;
//           }
//         }
//       `}</style>

//       <Modal
//         show={show}
//         onHide={onHide}
//         centered
//         backdrop="static"
//         className="custom-responsive-modal"
//       >
//         <div style={{ padding: "24px 20px", position: "relative" }}>
//           <IconButton
//             onClick={onHide}
//             style={{ position: "absolute", right: 12, top: 12, color: "#666" }}
//           >
//             <Close />
//           </IconButton>

//           <h4
//             style={{
//               marginBottom: "20px",
//               fontWeight: "600",
//               color: "#1a1a1a",
//               fontSize: "1.25rem",
//             }}
//           >
//             Get Expert Consultation
//           </h4>

//           <Form onSubmit={handleSubmit}>
//             {/* Full Name */}
//             <div className="mb-3">
//               <TextField
//                 label="Full Name"
//                 value={name}
//                 fullWidth
//                 size="small"
//                 onChange={(e) => setName(e.target.value)}
//                 error={!!errors.name}
//                 helperText={errors.name}
//               />
//             </div>

//             {/* Role Dropdown */}
//             <div className="mb-3">
//               <TextField
//                 select
//                 label="I am a"
//                 value={role}
//                 fullWidth
//                 size="small"
//                 onChange={(e) => setRole(e.target.value)}
//                 error={!!errors.role}
//                 helperText={errors.role}
//               >
//                 <MenuItem value="Broker">Broker</MenuItem>
//                 <MenuItem value="Developer">Developer</MenuItem>
//                 <MenuItem value="Real Estate Professional">
//                   Real Estate Professional
//                 </MenuItem>
//               </TextField>
//             </div>

//             {/* Contact Number & Inline Verify Button */}
//             <div className="mb-3">
//               <TextField
//                 label="Contact Number"
//                 value={number}
//                 fullWidth
//                 size="small"
//                 disabled={showOtpSection || isPhoneVerified}
//                 onChange={(e) => setNumber(e.target.value)}
//                 error={!!errors.contactNo}
//                 helperText={errors.contactNo}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       {isPhoneVerified ? (
//                         <span
//                           style={{
//                             color: "#2e7d32",
//                             display: "flex",
//                             alignItems: "center",
//                             fontSize: "12px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           <CheckCircle
//                             fontSize="small"
//                             style={{ marginRight: "3px" }}
//                           />{" "}
//                           Verified
//                         </span>
//                       ) : (
//                         !showOtpSection && (
//                           <MuiButton
//                             size="small"
//                             variant="contained"
//                             disableElevation
//                             onClick={handleSendOtp}
//                             disabled={loading}
//                             style={{
//                               textTransform: "none",
//                               fontSize: "12px",
//                               padding: "4px 10px",
//                             }}
//                           >
//                             Send OTP
//                           </MuiButton>
//                         )
//                       )}
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </div>

//             {/* Inline OTP Section */}
//             {showOtpSection && !isPhoneVerified && (
//               <div
//                 style={{
//                   padding: "12px",
//                   backgroundColor: "#f8f9fa",
//                   borderRadius: "8px",
//                   border: "1px dashed #1976d2",
//                   marginBottom: "16px",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     marginBottom: "8px",
//                     fontSize: "12px",
//                   }}
//                 >
//                   <span>Sent to +91 {number}</span>
//                   <span
//                     onClick={() => setShowOtpSection(false)}
//                     style={{
//                       color: "#1976d2",
//                       cursor: "pointer",
//                       textDecoration: "underline",
//                       marginLeft: "8px",
//                     }}
//                   >
//                     Edit number
//                   </span>
//                 </div>

//                 {/* OTP Input Boxes */}
//                 <div
//                   style={{
//                     display: "flex",
//                     gap: "6px",
//                     justifyContent: "center",
//                     marginBottom: "12px",
//                   }}
//                 >
//                   {otp.map((digit, i) => (
//                     <input
//                       key={i}
//                       id={`modal-otp-${i}`}
//                       type="tel"
//                       inputMode="numeric"
//                       maxLength={1}
//                       value={digit}
//                       onChange={(e) => handleChangeOtp(e, i)}
//                       onKeyDown={(e) => handleKeyDownOtp(e, i)}
//                       style={{
//                         width: "100%",
//                         maxWidth: "38px",
//                         height: "38px",
//                         textAlign: "center",
//                         borderRadius: "6px",
//                         border: "1px solid #ccc",
//                         fontSize: "16px",
//                       }}
//                     />
//                   ))}
//                 </div>

//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     alignItems: "center",
//                     gap: "12px",
//                   }}
//                 >
//                   <span style={{ fontSize: "12px", color: "#666" }}>
//                     {canResend ? (
//                       <span
//                         onClick={handleSendOtp}
//                         style={{
//                           color: "#1976d2",
//                           cursor: "pointer",
//                           fontWeight: "600",
//                         }}
//                       >
//                         Resend OTP
//                       </span>
//                     ) : (
//                       `Resend in ${timer}s`
//                     )}
//                   </span>

//                   <Button
//                     size="sm"
//                     onClick={handleVerifyOtp}
//                     disabled={loading}
//                   >
//                     Verify OTP
//                   </Button>
//                 </div>
//               </div>
//             )}

//             <Button
//               type="submit"
//               className="w-100 mt-2"
//               variant="primary"
//               disabled={loading}
//               style={{ padding: "10px", fontWeight: "600" }}
//             >
//               {loading ? "Submitting..." : "Submit Details"}
//             </Button>
//           </Form>
//         </div>
//       </Modal>
//     </>
//   );
// };

// export default LeadCaptureModal;

import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import {
  TextField,
  MenuItem,
  IconButton,
  InputAdornment,
  Button as MuiButton,
} from "@mui/material";
import { CheckCircle, Close, Edit } from "@mui/icons-material";
import { toast, Toaster } from "react-hot-toast";

const STORAGE_KEY = "lead_modal_submitted";

const LeadCaptureModal = ({ show, onHide }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [role, setRole] = useState("");
  const [errors, setErrors] = useState({});

  // Flag to check if user has already submitted the modal form
  const [isSubmitted, setIsSubmitted] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === "true";
  });

  // OTP State
  const [showOtpSection, setShowOtpSection] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);

  // Map internal menu values to expected payload values
  const roleMapping = {
    Broker: "broker",
    Developer: "developer",
    "Real Estate Professional": "realEstate",
  };

  // OTP Resend Timer
  useEffect(() => {
    let interval;
    if (showOtpSection && timer > 0 && !isPhoneVerified) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [showOtpSection, timer, isPhoneVerified]);

  // Handle number input change - resets verification if changed
  const handleNumberChange = (e) => {
    setNumber(e.target.value);
    if (isPhoneVerified) {
      setIsPhoneVerified(false);
    }
    if (errors.contactNo) {
      setErrors((prev) => ({ ...prev, contactNo: "" }));
    }
  };

  const handleSendOtp = async () => {
    const contactRegex = /^\d{10}$/;
    if (!number.trim() || !contactRegex.test(number)) {
      setErrors((prev) => ({
        ...prev,
        contactNo: "Enter a valid 10-digit number",
      }));
      return;
    }

    setLoading(true);
    try {
      // Step 1: Pre-check user availability
      const checkUserRes = await fetch(
        "https://apilead.blaccdot.com/api/auth/check-user",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone: number }),
        }
      );
      const checkUserData = await checkUserRes.json();

      if (!checkUserRes.ok || checkUserData?.success === false) {
        // Check if the user is already registered
        if (
          checkUserData?.message?.toLowerCase().includes("already exists")
        ) {
          toast.error("You are already a registered user. Please log in!");
        } else {
          toast.error(checkUserData?.message || "User validation failed");
        }
        return;
      }

      // Step 2: Send OTP
      const otpRes = await fetch(
        "https://euctostaging.com/lms/api/send-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone_number: number }),
        }
      );
      const otpData = await otpRes.json();

      if (otpRes.ok && otpData.success) {
        toast.success(otpData.message || "OTP sent successfully!");
        setShowOtpSection(true);
        setTimer(30);
        setCanResend(false);
        setErrors((prev) => ({ ...prev, contactNo: "" }));
      } else {
        toast.error(otpData.message || "Failed to send OTP");
      }
    } catch (err) {
      toast.error("Error sending OTP");
    } finally {
      setLoading(false);
    }
  };
  const handleVerifyOtp = async () => {
    const fullOtp = otp.join("");
    if (fullOtp.length !== 6) {
      toast.error("Enter complete 6-digit OTP");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(
        "https://euctostaging.com/lms/api/verify-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone_number: number, otp: fullOtp }),
        }
      );

      const result = await res.json();

      if (result.success) {
        toast.success(result.message || "Mobile number verified!");
        setIsPhoneVerified(true);
        setShowOtpSection(false);
      } else {
        toast.error(result.message || "Invalid OTP. Try again.");
      }
    } catch (err) {
      toast.error("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  const handleChangeOtp = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`modal-otp-${index + 1}`)?.focus();
    }
  };

  const handleKeyDownOtp = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
        document.getElementById(`modal-otp-${index - 1}`)?.focus();
      }
      e.preventDefault();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!name.trim()) errs.name = "Name is required";
    if (!role) errs.role = "Please select a role";
    if (!number.trim() || !/^\d{10}$/.test(number))
      errs.contactNo = "Enter a valid 10-digit number";

    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    if (!isPhoneVerified) {
      toast.error("Please verify your mobile number first!");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        "https://apilead.blaccdot.com/api/auth/user-interaction",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: name,
            mobileNo: number,
            userCategory: roleMapping[role],
          }),
        }
      );

      const data = await response.json();

      if (response.ok && data?.success !== false) {
        toast.success(data?.message || "Details submitted successfully!");

        // Save state to prevent modal from opening again
        localStorage.setItem(STORAGE_KEY, "true");
        setIsSubmitted(true);

        onHide();
      } else {
        toast.error(data?.message || "Failed to submit interaction details");
      }
    } catch (err) {
      toast.error("Error submitting details");
    } finally {
      setLoading(false);
    }
  };

  // Do not render the modal if user has already submitted the form
  if (isSubmitted) return null;

  return (
    <>
      <Toaster position="top-center" containerStyle={{ zIndex: 99999 }} />

      <style>{`
        @media (max-width: 576px) {
          .custom-responsive-modal .modal-dialog {
            margin-left: 16px !important;
            margin-right: 16px !important;
            max-width: calc(100% - 32px) !important;
          }
        }
      `}</style>

      <Modal
        show={show}
        onHide={onHide}
        centered
        backdrop="static"
        className="custom-responsive-modal"
      >
        <div style={{ padding: "24px 20px", position: "relative" }}>
          <IconButton
            onClick={onHide}
            style={{ position: "absolute", right: 12, top: 12, color: "#666" }}
          >
            <Close />
          </IconButton>

          <h4
            style={{
              marginBottom: "20px",
              fontWeight: "600",
              color: "#1a1a1a",
              fontSize: "1.25rem",
            }}
          >
            Get Expert Consultation
          </h4>

          <Form onSubmit={handleSubmit}>
            {/* Full Name */}
            <div className="mb-3">
              <TextField
                label="Full Name"
                value={name}
                fullWidth
                size="small"
                onChange={(e) => setName(e.target.value)}
                error={!!errors.name}
                helperText={errors.name}
              />
            </div>

            {/* Role Dropdown */}
            <div className="mb-3">
              <TextField
                select
                label="I am a"
                value={role}
                fullWidth
                size="small"
                onChange={(e) => setRole(e.target.value)}
                error={!!errors.role}
                helperText={errors.role}
              >
                <MenuItem value="Broker">Broker</MenuItem>
                <MenuItem value="Developer">Developer</MenuItem>
                <MenuItem value="Real Estate Professional">
                  Real Estate Professional
                </MenuItem>
              </TextField>
            </div>

            {/* Contact Number & Inline Verification State */}
            <div className="mb-3">
              <TextField
                label="Contact Number"
                value={number}
                fullWidth
                size="small"
                disabled={showOtpSection}
                onChange={handleNumberChange}
                error={!!errors.contactNo}
                helperText={errors.contactNo}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {isPhoneVerified ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <span
                            style={{
                              color: "#2e7d32",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            <CheckCircle
                              fontSize="small"
                              style={{ marginRight: "3px" }}
                            />{" "}
                            Verified
                          </span>
                          <MuiButton
                            size="small"
                            onClick={() => setIsPhoneVerified(false)}
                            style={{
                              minWidth: "auto",
                              padding: "2px 6px",
                              fontSize: "11px",
                              textTransform: "none",
                            }}
                          >
                            Change
                          </MuiButton>
                        </div>
                      ) : (
                        !showOtpSection && (
                          <MuiButton
                            size="small"
                            variant="contained"
                            disableElevation
                            onClick={handleSendOtp}
                            disabled={loading}
                            style={{
                              textTransform: "none",
                              fontSize: "12px",
                              padding: "4px 10px",
                            }}
                          >
                            Send OTP
                          </MuiButton>
                        )
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* Inline OTP Section */}
            {showOtpSection && !isPhoneVerified && (
              <div
                style={{
                  padding: "12px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                  border: "1px dashed #1976d2",
                  marginBottom: "16px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "8px",
                    fontSize: "12px",
                  }}
                >
                  <span>Sent to +91 {number}</span>
                  <span
                    onClick={() => setShowOtpSection(false)}
                    style={{
                      color: "#1976d2",
                      cursor: "pointer",
                      textDecoration: "underline",
                      marginLeft: "8px",
                    }}
                  >
                    Edit number
                  </span>
                </div>

                {/* OTP Input Boxes */}
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    justifyContent: "center",
                    marginBottom: "12px",
                  }}
                >
                  {otp.map((digit, i) => (
                    <input
                      key={i}
                      id={`modal-otp-${i}`}
                      type="tel"
                      inputMode="numeric"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleChangeOtp(e, i)}
                      onKeyDown={(e) => handleKeyDownOtp(e, i)}
                      style={{
                        width: "100%",
                        maxWidth: "38px",
                        height: "38px",
                        textAlign: "center",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        fontSize: "16px",
                      }}
                    />
                  ))}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <span style={{ fontSize: "12px", color: "#666" }}>
                    {canResend ? (
                      <span
                        onClick={handleSendOtp}
                        style={{
                          color: "#1976d2",
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                      >
                        Resend OTP
                      </span>
                    ) : (
                      `Resend in ${timer}s`
                    )}
                  </span>

                  <Button
                    size="sm"
                    onClick={handleVerifyOtp}
                    disabled={loading}
                  >
                    Verify OTP
                  </Button>
                </div>
              </div>
            )}

            <Button
              type="submit"
              className="w-100 mt-2"
              variant="primary"
              disabled={loading}
              style={{ padding: "10px", fontWeight: "600" }}
            >
              {loading ? "Submitting..." : "Submit Details"}
            </Button>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default LeadCaptureModal;